import {NgModule} from "@angular/core";
import {LoginService} from "./services/login.service";
import {AuthProxy} from "../../common";
import {AssetProxy} from "../../common/http/services/assets.proxy";
import {DirectoryServiceService} from "./components/directory.service.selection/services/directory.service.service";
import {DirectoryServiceProxy} from "./components/directory.service.selection/services/directory.service.proxy";

@NgModule({
})
export class LoginProvidersModule{
	public static forRoot(){
		return {
			ngModule: LoginProvidersModule,
			providers: 	[
				LoginService,
				AuthProxy,
				AssetProxy,
				DirectoryServiceService,
				DirectoryServiceProxy
			]
		};
	}
}
